import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useGlobalization } from '@Translations/useGlobalization';

interface Props {
	isRunning: boolean;
	/** False for Viewers — they can't open Risk Setup. */
	canEdit: boolean;
	configId: string;
}

// Shown in place of the KPI row AND the grid until the model has a completed
// run — never a row of zeros pretending to be a result.
export const ResultsEmptyState = ({ isRunning, canEdit, configId }: Props) => {
	const { t } = useGlobalization();
	const history = useHistory();

	return (
		<Box
			data-cy="risk-results-empty"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: 2,
				py: 8,
				textAlign: 'center',
			}}>
			{isRunning ? (
				<>
					<CircularProgress size={32} />
					<Typography variant="h6">
						{t('Calculating risk…')}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{t('Results will appear here when the run completes.')}
					</Typography>
				</>
			) : (
				<>
					<Typography variant="h6">
						{t('This model has not been run yet')}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{t(
							'Run the model from Risk Setup to see how many assets fall in each risk grade.',
						)}
					</Typography>
					{canEdit && (
						<Button
							variant="contained"
							data-cy="risk-results-empty-go-setup"
							onClick={() =>
								history.push(`/risk/riskSetup/${configId}`)
							}>
							{t('Go to Risk Setup')}
						</Button>
					)}
				</>
			)}
		</Box>
	);
};

export default ResultsEmptyState;
